/* Rhody Reviews api/v1 -- feedback board domain (native feature-request board;
   HOPPER + CORBATO, pre-launch Step 2, 2026-07-14).

   Signed-in clients post feature requests and upvote others; top-requested
   items surface by vote count. Built on our own Supabase + Supabase Auth --
   no separate account, no third-party host. */
import { request } from './_http';

export type FeedbackStatus =
  | 'open'
  | 'planned'
  | 'in_progress'
  | 'done'
  | 'declined';

export interface FeedbackPost {
  id: string;
  title: string;
  body: string | null;
  status: FeedbackStatus | string;
  created_at: string | null;
  updated_at: string | null;
  vote_count: number;
  /* Did the SIGNED-IN tenant upvote this post. */
  has_voted: boolean;
  /* Did the signed-in tenant author this post (drives the edit affordance).
     The board never exposes WHICH other business authored a post. */
  is_author: boolean;
}

export interface FeedbackPostsResponse {
  client_id: string;
  count: number;
  statuses: string[];
  posts: FeedbackPost[];
}

export interface FeedbackVoteResponse {
  client_id: string;
  post_id: string;
  voted: boolean;
  vote_count: number;
}

export const feedbackBoardApi = {
  listFeedbackPosts(signal?: AbortSignal): Promise<FeedbackPostsResponse> {
    return request<FeedbackPostsResponse>('/api/v1/feedback-board/posts', { signal });
  },
  createFeedbackPost(input: {
    title: string;
    body?: string;
  }): Promise<{ client_id: string; post: FeedbackPost }> {
    return request<{ client_id: string; post: FeedbackPost }>(
      '/api/v1/feedback-board/posts',
      { method: 'POST', body: input },
    );
  },
  updateFeedbackPost(
    id: string,
    patch: { title?: string; body?: string },
  ): Promise<{ client_id: string; post: FeedbackPost }> {
    return request<{ client_id: string; post: FeedbackPost }>(
      `/api/v1/feedback-board/posts/${encodeURIComponent(id)}`,
      { method: 'PATCH', body: patch },
    );
  },
  toggleFeedbackVote(id: string): Promise<FeedbackVoteResponse> {
    return request<FeedbackVoteResponse>(
      `/api/v1/feedback-board/posts/${encodeURIComponent(id)}/vote`,
      { method: 'POST' },
    );
  },
};
